/* eslint-disable no-magic-numbers, class-methods-use-this */

const makeSpectrum = (root, harmonics) => {
	const res = [root];
	for (let i = 2; i < harmonics; i++) {
		res.push(i * root);
	}
	return res;
};

const makeHit = (velocity, root, harmonics) => ({
	velocity,
	spectrum: makeSpectrum(root, harmonics)
});

export default class RhythmFactory {

	createMetronome(beats, opts) {
		const {
			num = 1,
			div = 1,
			fundamental = 40,
			harmonics0 = 2,
			harmonics = 2,
			velocity0 = 1,
			velocity = 0.8
		} = opts || {};
		let sequence = 'X';
		for (let i = 1; i < beats; i++) {
			sequence += 'o';
		}
		return {
			num,
			div,
			sequence,
			dynamics: {
				X: makeHit(velocity0, fundamental, harmonics0),
				o: makeHit(velocity, fundamental, harmonics)
			}
		};
	}

}
